import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Cea {
  static getById (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_carga_entrante_automotor?r=` +
      `{"clave":{"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }

  static getCeaTicketDescarga (numero) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_cea_ticket_descarga?r=` +
      `{"clave":{"carta_de_porte_automotor": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default Cea
